exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DraftEditorInput .demo-wrapper{border:1px solid #f1f1f1}.DraftEditorInput .rdw-editor-main{min-height:200px;padding:0 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/TextFieldWysiwyg/DraftEditorInput.scss
// module id = 4817
// module chunks = 0